const initialState = {
  isAuthenticating: false,
  isAuthenticated: false,
  hasAuthenticatingError: false,
  errorMessage: '',
  user: null,
  userId: null,
  userData: null,
  isLoading: false,
  hasLoadingError: false,
  activeView: 'resource',
  users: [],
  roles: [],
  permissions: []
};

export default initialState;
